import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

if (!window.ultimadeskAjaxAddToCartInitialized) {
  window.ultimadeskAjaxAddToCartInitialized = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.js-ajax-add-to-cart-form');

    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('[data-ref="add-to-cart-button"]');
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer) {
      console.error('[Ultimadesk] Cart drawer introuvable.');
      return;
    }

    const sectionId = cartDrawer.dataset.sectionId;

    if (!sectionId) {
      console.error('[Ultimadesk] data-section-id introuvable sur cart-drawer.');
      return;
    }

    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    try {
      const formData = new FormData(form);

      formData.append('sections', sectionId);
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const parsedResponse = await response.json();

      if (!response.ok) {
        const message = parsedResponse.description || parsedResponse.message || 'Impossible d’ajouter le produit au panier.';
        throw new Error(message);
      }

      const cartResponse = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });

      const cart = await cartResponse.json();

      document.dispatchEvent(
        new CartUpdatedEvent(
          {},
          {
            itemCount: cart.item_count,
            source: 'ultimadesk-ajax-add-to-cart',
            sections: parsedResponse.sections,
          },
        ),
      );

      document.dispatchEvent(new CustomEvent(ThemeEvents.cartOpen));
    } catch (error) {
      console.error('[Ultimadesk] Erreur ajout panier AJAX :', error);

      document.dispatchEvent(
        new CustomEvent('toast:open', {
          detail: {
            type: 'error',
            message: error.message || 'Erreur lors de l’ajout au panier.',
          },
        }),
      );
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
}